export default __webpack_public_path__ + "static/media/email.6f4a4684.svg";